export const DEFAULT_MARKER_COLOR = "#FF4D30";
export const BLUE_MARKER_COLOR = "#000087";
export const HIGHLIGHTED_MARKER_COLOR = "#000087";
export const DEFAULT_ZINDEX_MARKER = 1000;
export const MAX_ZINDEX_MARKER = 9999;
export const DEFAULT_LABEL_FONT_WEIGHT = "500";
export const DEFAULT_LABEL_COLOR = "white";
export const DEFAULT_MAP_ZOOM = 2;
export const MAP_ZOOM = 11;
export const TRAVEL_MAP_ZOOM = 15;
export const INSPECTION_MARKER_SVG =
  "M12 2c3.86 0 7 3.14 7 7 0 5.25-7 13-7 13S5 14.25 5 9c0-3.86 3.14-7 7-7zm-1.53 12L17 7.41 15.6 6l-5.13 5.18L8.4 9.09 7 10.5l3.47 3.5z";
export const INSPECTOR_MARKER_SVG =
  "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z";
